import styled, { keyframes } from "styled-components";
import { dashboardTheme } from "../../theme/dashboardTheme";

const shimmer = keyframes`
  0% { opacity: 0.55; }
  50% { opacity: 1; }
  100% { opacity: 0.55; }
`;

export const SkeletonBlock = styled.div<{ $height?: string; $width?: string }>`
  height: ${({ $height }) => $height ?? "1rem"};
  width: ${({ $width }) => $width ?? "100%"};
  border-radius: 8px;
  background: ${dashboardTheme.colors.skeleton};
  animation: ${shimmer} 1.4s ease-in-out infinite;
`;

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
`;

export const SkeletonRow = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
`;
